export const RGDS = 'rgds';
export const LIFEN = 'lifen';
export function getDomainFromUrl(url) {
  return url && url.indexOf('ramsaygds') > -1 ? RGDS : LIFEN;
}
